import { Component, Input } from '@angular/core';
import { Product } from '../../../../graphql/generated/generated-types';


@Component({
  selector: 'app-product-details-description',
  standalone: true,
  imports: [],
  templateUrl: './product-details-description.component.html',
  styleUrl: './product-details-description.component.scss'
})
export class ProductDetailsDescriptionComponent {
    @Input() description!: string;
}
